import { homeBreadcrumbEntry, normalizeRoute } from "../../../rewamp/contexts/breadcrumbStackUtils";

export const grmRoute = (path = "") => `${window.contextPath || ""}/${path}`;

// The stack bar resolves labelKey with plain tRewamp, so stream copy is applied here.
export const grmCrumbs = (stream) => {
  const labelKey = (key) => stream.copy[key] ?? key;
  const list = {
    id: `${stream.id}-list`,
    labelKey: labelKey("GRM_LIST.BREADCRUMB"),
    route: normalizeRoute(grmRoute(stream.route)),
  };
  return {
    list,
    raise: {
      id: `${stream.id}-raise`,
      labelKey: labelKey("GRM_RAISE.BREADCRUMB"),
      route: normalizeRoute(grmRoute(`${stream.route}/new`)),
    },
    otp: {
      id: `${stream.id}-raise-otp`,
      labelKey: "GRM_RAISE.OTP_TITLE",
      route: normalizeRoute(grmRoute(`${stream.route}/new`)),
    },
    ticket: (ticketId) => ({
      id: `${stream.id}-ticket`,
      label: ticketId,
      route: normalizeRoute(grmRoute(`${stream.route}/${encodeURIComponent(ticketId)}`)),
    }),
    reopenOtp: (ticketId) => ({
      id: `${stream.id}-reopen-otp`,
      labelKey: "GRM_RAISE.OTP_TITLE",
      route: normalizeRoute(grmRoute(`${stream.route}/${encodeURIComponent(ticketId)}`)),
    }),
    listAncestors: [homeBreadcrumbEntry()],
    pageAncestors: [homeBreadcrumbEntry(), list],
  };
};
